module.exports = __webpack_public_path__ + "static/img/invest-TMT2.4443971.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/investCase/invest-TMT2.jpg
// module id = L8i+
// module chunks = 0